import { useMemo } from 'react';
import { useTabs } from '@shared/hooks';
import { AccountType } from '@shared/api/rest/accounts';
import { PaymentTab, CardTab } from './widgets';
import { NoData, PageContainer, Spinner, Tabs } from '@shared/widgets';

export const DashboardPage = () => {
  const tabsState = useTabs();

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <PaymentTab />;
    else if (tabsState.tab === AccountType.Card) return <CardTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);

  return (
    <PageContainer title='Dashboard' header='Dashboard'>
      <div className='flex flex-col gap-12'>
        {!tabsState.loading && tabsState.hasCard && tabsState.hasPayment && (
          <Tabs options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
        )}
        {currentTabView}
      </div>
    </PageContainer>
  );
};
